import { Directive, Input, OnInit, TemplateRef, ViewContainerRef, OnDestroy } from '@angular/core';
import { ERoles } from '../_models/entities/roles';
import { RolePermissionsService } from '../_services/role-permissions.service';
import { UserService } from '../_services/user.service';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[appRoleContextMenu]'
})
export class RoleContextMenuDirective implements OnInit, OnDestroy {
  @Input() appRoleContextMenu: string = ''; // Module name
  @Input() menuItems: any[] = [];
  @Input() userRole: string = '';

  private subscription: Subscription = new Subscription();
  private hasView = false;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private rolePermissionsService: RolePermissionsService,
    private userService: UserService
  ) {}

  ngOnInit() {
    this.subscription.add(
      this.userService.currentUser$.subscribe((user) => {
        const roleNames: string[] =
          Array.isArray(user?.roles) && user.roles.length > 0
            ? user.roles.map((r: any) => r.name).filter(Boolean)
            : user?.role?.name
              ? [user.role.name]
              : [];
        if (roleNames.length > 0) {
          this.updateView(roleNames);
        }
      })
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  private updateView(userRoles: string[]) {
    // Check if any of the user's roles grants access to the module
    const hasModuleAccess = userRoles.some((role) =>
      this.rolePermissionsService.hasModuleAccess(this.appRoleContextMenu, role)
    );

    if (hasModuleAccess && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (!hasModuleAccess && this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }

  /**
   * Filter menu items based on user permissions
   * @param items - Menu items to filter
   * @param userRole - User's role
   * @returns Filtered menu items
   */
  filterMenuItems(items: any[], userRole: string): any[] {
    return this.rolePermissionsService.filterContextMenuItems(
      this.appRoleContextMenu,
      items,
      userRole
    );
  }
}
